const EOCStatus = {
  Cancelled: 'Cancelled',
  Evaluation: 'Evaluation',
  NonSurgicalBundle: 'Non-Surgical Bundle',
  NonSurgical: 'Non-Surgical',
  None: '',
  SurgicalBundle: 'Surgical Bundle',
  SxPostponed: 'Sx Postponed',
  CaseClosed: 'MMI/Case Closed',
  InjectionBundle: 'Injection Bundle',
  PotentialNonSurgical: 'Potential Non-Surgical',
}

export const EOCStatusOptions = Object.values(EOCStatus)
  .filter((status) => status !== EOCStatus.None)
  .sort()

export default EOCStatus
